import React, { useState, useEffect } from 'react';
import HotChartServices from '../../services/HotChartServices';

function UserHotChart() {
    const [contactData, setContactData] = useState([]);
    const [date, setDate] = useState('');
    const currentDate = new Date().toISOString().split('T')[0];

    useEffect(() => {
        fetchData(date || currentDate);
    }, [date]);

    const fetchData = (selectedDate) => {
        HotChartServices.getTodayHotChart(selectedDate)
            .then((response) => {
                setContactData(response?.data || []);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleDateChange = (e) => {
        setDate(e.target.value);
    };

    const formatDateTime = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };


    return (
        <div>
            <div className="row justify-content-end px-4 pt-3">
                <div className="col-md-3">
                    <input
                        className="form-control"
                        type="date"
                        id="dateInput"
                        value={date || currentDate}
                        onChange={handleDateChange}
                    />
                </div>
            </div>

            <div className="contact-us-section py-4">
                <div className="container">
                    {/* <h2 className="heading text-center mb-4">Hot Chart</h2> */}
                    <div className="row gy-4">
                        {contactData.length === 0 && (
                            <p className="text-center">No data found for the selected date.</p>
                        )}

                        {contactData.map((data, index) => (
                            <div className="col-md-12" key={index}>
                                <div className="d-flex border rounded shadow-sm p-3 h-100 align-items-start" style={{ gap: '1.5rem' }}>
                                    <div style={{ flex: '0 0 220px', height: '220px' }}>
                                        <a
                                            href={`${process.env.REACT_APP_URL}${data?.image}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={`${process.env.REACT_APP_URL}${data?.image}`}
                                                alt="Hot Chart"
                                                className="img-fluid rounded"
                                                style={{
                                                    width: '220px',
                                                    height: '220px',
                                                    objectFit: 'cover',
                                                    borderRadius: '10px'
                                                }}
                                            />
                                        </a>
                                    </div>
                                    <div className="flex-grow-1">
                                        <h5><strong>Symbol:</strong> {data.symbol}</h5>
                                        <p><strong>Description:</strong> {data.description}</p>
                                        <p className="text-muted"><strong>Created:</strong> {formatDateTime(data.createdAt)}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserHotChart;
